// extracted by mini-css-extract-plugin
export default {"customSelect":"styles_customSelect__PiCZ5"};